















import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  EditedImages,
  EditedImagesDTO,
  ImageStatus,
  JbicImage,
  JbicImageVersion
} from '@/store/modules/admin/types/admin.types';

// components
import { PaginationMixin } from '@/components/base/pagination.mixin';
import ImageCard from './ImageCard.vue';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';

@Component({
  components: {
    ImageCard
  }
})
export default class ImagesGrid extends mixins(PaginationMixin) {
  @Prop() public items!: JbicImage[];
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  @Prop() public imageStatus!: ImageStatus;
  @Prop(Boolean) public isSelectAll!: boolean;
  @Prop(Boolean) public isDeselectAll!: boolean;

  @Action('admin/getEditedImages')
  getEditedImages!: (imageIds?: EditedImagesDTO) => void;

  @State(({ admin }: RootState) => admin.apiState.getEditedImages)
  getEditedImagesApiState!: ApiState;

  @State(({ admin }: RootState) => admin.editedImages)
  editedImages!: EditedImages;

  public selectedItems: number[] = [];
  public previousVersionImages: JbicImageVersion[] = [];

  getSelect(imageId: number): boolean {
    return this.selectedItems.some((item) => item === imageId);
  }

  handleSelectImage(params: { imageId: number; isSelected: boolean }) {
    const imageIndex: number = this.selectedItems.indexOf(params.imageId);

    if (params.isSelected) {
      if (imageIndex > -1) {
        return;
      }
      this.selectedItems.push(params.imageId);
    } else {
      if (imageIndex < 0) {
        return;
      }
      this.selectedItems.splice(imageIndex, 1);
    }
  }

  getPreviousVersion(imageId: number): JbicImageVersion | undefined {
    return this.previousVersionImages.find(
      (image) => image.imageId === imageId
    );
  }

  mounted() {
    const imageIds: number[] = this.items.map((item) => item.id);
    this.getEditedImages({ ids: imageIds });
  }

  @Watch('isSelectAll')
  onIsSelectAll() {
    const isSelectAll: boolean = this.isSelectAll;

    if (isSelectAll) {
      this.selectedItems = [];
      this.items.forEach((item) => {
        this.selectedItems.push(item.id);
      });
    }
  }

  @Watch('isDeselectAll')
  onIsDeselectAll() {
    const isDeselectAll: boolean = this.isDeselectAll;

    if (isDeselectAll) {
      this.selectedItems = [];
    }
  }

  @Watch('getEditedImagesApiState')
  onEditedImages() {
    if (
      this.getEditedImagesApiState.loading ||
      !this.getEditedImagesApiState.success ||
      this.getEditedImagesApiState.error
    ) {
      return;
    }

    const lastReviewImages = this.editedImages.lastReviewImages;

    if (!lastReviewImages) {
      return;
    }

    this.previousVersionImages = [];
    lastReviewImages.forEach((lastReviewImage) => {
      this.previousVersionImages.push(lastReviewImage);
    });
  }

  @Watch('selectedItems', { deep: true })
  onSelectedItems() {
    this.$emit('selectImages', this.selectedItems);
  }

  @Watch('imageStatus')
  onStatusChange() {
    this.selectedItems = [];
  }
}
